import { BadgesGenerator } from './BadgesGenerator.component';

export { BadgesGenerator };
